// EL PIN DEL KIOSKO DE MARCAR (DUVAN-PIN-T1, Ares #19889, 28-sep).
//
// El panel fija PINs de 4 a 6 digitos (ColaboradoresView: /^\d{4,6}$/; la API: AsistenciaService.SetPinAsync) y
// inventario (OperadorPin) los acepta hasta 6. Pero el kiosko de marcar (MarcacionView) tenia el 5 clavado: solo
// dejaba teclear 5 digitos y mandaba solo al quinto. Un PIN de 4 no se podia mandar; uno de 6 salia cortado en 5 y la
// API respondia PIN incorrecto (Duvan: marcar 422 tres veces el 28-sep 11:57 con el mismo PIN que inventario acepto).
//
// La regla aqui, pura (la prueba scripts/check-kiosko-pin.mjs): de 4 a 6 digitos; con 4 o 5 se confirma con el boton o
// Enter; al sexto se manda solo (no cabe otro).

export const PIN_MIN = 4;
export const PIN_MAX = 6;

/** El PIN con un digito mas, si cabe; si no es un digito o ya esta lleno, igual. */
export function agregarDigito(pin, d) {
  return /^\d$/.test(String(d)) && pin.length < PIN_MAX ? pin + d : pin;
}

/** Se puede mandar: solo digitos, de 4 a 6. */
export function puedeEnviar(pin) {
  return /^\d+$/.test(pin) && pin.length >= PIN_MIN && pin.length <= PIN_MAX;
}

/** Se manda solo al llenarse (6): no hay PIN mas largo que esperar. */
export function seEnviaSolo(pin) {
  return pin.length === PIN_MAX;
}

export const AVISO_CORTO = `El PIN tiene de ${PIN_MIN} a ${PIN_MAX} numeros. Escribelo y toca ✓.`;
